import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeakerOff16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSpeakerOff16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.765 6.112h.39l.287-.263 2.01-1.847v8.06l-2.01-1.847-.287-.264H3.5a.5.5 0 0 1-.5-.5V6.612a.5.5 0 0 1 .5-.5zM2 6.612a1.5 1.5 0 0 1 1.5-1.5h1.265l2.849-2.617a.5.5 0 0 1 .838.369V13.2a.5.5 0 0 1-.838.368l-2.849-2.617H3.5a1.5 1.5 0 0 1-1.5-1.5zm8.056-.529a.5.5 0 0 1 .707 0l1.148 1.148 1.148-1.148a.5.5 0 1 1 .707.707l-1.148 1.15 1.147 1.148a.5.5 0 0 1-.707.707l-1.147-1.148-1.148 1.148a.5.5 0 1 1-.707-.707l1.148-1.148-1.148-1.149a.5.5 0 0 1 0-.707"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeakerOff16);
